export const VIDEO_STORIES_OVERLAY_TEMPLATE = 'VideoStoryPlaybackInterface.v1_0.VideoStoriesOverlayTemplate';
